export default function popupSelectFilter() {
    return function (input, param) {
        if (!Array.isArray(input) || input === null || input === undefined) return input
        return input.filter((item) => item.code && item.name && (item.code.indexOf(param) != -1 || item.name.indexOf(param) != -1))
    }
}



// WEBPACK FOOTER //
// ./src/common/services/popupSelectFilter.js